!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("vue-froala-wysiwyg", [], e) : "object" == typeof exports ? exports["vue-froala-wysiwyg"] = e() : t["vue-froala-wysiwyg"] = e();
}(window, function () {
  return function (t) {
    var e = {};
    function n(i) {
      if (e[i]) return e[i].exports;
      var r = e[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) n.d(i, r, function (e) {
        return t[e];
      }.bind(null, r));
      return i;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 0);
  }([function (t, e, n) {
    "use strict";

    n.r(e), e.default = function (t) {
      arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      var e = {
        props: ["tag", "value", "config", "onManualControllerReady"],
        watch: {
          value: function () {
            this.model = this.value, this.updateValue();
          }
        },
        render: function (t) {
          return t(this.currentTag, [this.$slots.default]);
        },
        created: function () {
          this.currentTag = this.tag || this.currentTag, this.model = this.value;
        },
        mounted: function () {
          -1 != this.SPECIAL_TAGS.indexOf(this.currentTag) && (this.hasSpecialTag = !0), this.onManualControllerReady ? this.generateManualController() : this.createEditor();
        },
        beforeDestroy: function () {
          this.destroyEditor();
        },
        data: function () {
          return {
            currentTag: "div",
            listeningEvents: [],
            _$element: null,
            _$editor: null,
            currentConfig: null,
            defaultConfig: {
              immediateVueModelUpdate: !1,
              vueIgnoreAttrs: null
            },
            editorInitialized: !1,
            SPECIAL_TAGS: ["img", "button", "input", "a"],
            INNER_HTML_ATTR: "innerHTML",
            hasSpecialTag: !1,
            model: null,
            oldModel: null
          };
        },
        methods: {
          updateValue: function () {
            JSON.stringify(this.oldModel) != JSON.stringify(this.model) && this.setContent();
          },
          createEditor: function () {
            this.editorInitialized || (this.currentConfig = this.config || this.defaultConfig, this._$element = jQuery(this.$el), this.setContent(!0), this.registerEvents(), this._$editor = this._$element.froalaEditor(this.currentConfig).data("froala.editor").$el, this.initListeners(), this.editorInitialized = !0);
          },
          setContent: function (t) {
            (this.editorInitialized || t) && (this.model || "" == this.model) && (this.oldModel = this.model, this.hasSpecialTag ? this.setSpecialTagContent() : this.setNormalTagContent(t));
          },
          setNormalTagContent: function (t) {
            var e = this;
            function n() {
              e._$element.froalaEditor("html.set", e.model || "", !0), e._$element.froalaEditor("undo.saveStep"), e._$element.froalaEditor("undo.reset");
            }
            t ? this.registerEvent(this._$element, "froalaEditor.initialized", function () {
              n();
            }) : n();
          },
          setSpecialTagContent: function () {
            var t = this.model;
            if (t) {
              for (var e in t) t.hasOwnProperty(e) && e != this.INNER_HTML_ATTR && this._$element.attr(e, t[e]);
              t.hasOwnProperty(this.INNER_HTML_ATTR) && (this._$element[0].innerHTML = t[this.INNER_HTML_ATTR]);
            }
          },
          destroyEditor: function () {
            this._$element && (this.listeningEvents && this._$element.off(this.listeningEvents.join(" ")), this._$editor.off("keyup"), this._$element.froalaEditor("destroy"), this.listeningEvents.length = 0, this._$element = null, this.editorInitialized = !1);
          },
          getEditor: function () {
            return this._$element ? this._$element.froalaEditor.bind(this._$element) : null;
          },
          generateManualController: function () {
            var t = {
              initialize: this.createEditor,
              destroy: this.destroyEditor,
              getEditor: this.getEditor
            };
            this.onManualControllerReady(t);
          },
          updateModel: function () {
            var t = "";
            if (this.hasSpecialTag) {
              for (var e = this._$element[0].attributes, n = {}, i = 0; i < e.length; i++) {
                var r = e[i].name;
                this.currentConfig.vueIgnoreAttrs && -1 != this.currentConfig.vueIgnoreAttrs.indexOf(r) || (n[r] = e[i].value);
              }
              this._$element[0].innerHTML && (n[this.INNER_HTML_ATTR] = this._$element[0].innerHTML), t = n;
            } else {
              var o = this._$element.froalaEditor("html.get");
              "string" == typeof o && (t = o);
            }
            this.oldModel = t, this.$emit("input", t);
          },
          initListeners: function () {
            var t = this;
            this.registerEvent(this._$element, "froalaEditor.contentChanged", function () {
              t.updateModel();
            }), this.currentConfig.immediateVueModelUpdate && this.registerEvent(this._$editor, "keyup", function () {
              t.updateModel();
            });
          },
          registerEvent: function (t, e, n) {
            t && e && n && (this.listeningEvents.push(e), t.on(e, n));
          },
          registerEvents: function () {
            var t = this.currentConfig.events;
            if (t) for (var e in t) t.hasOwnProperty(e) && this.registerEvent(this._$element, e, t[e]);
          }
        }
      };
      t.component("Froala", e);
      var n = {
        props: ["tag", "value"],
        watch: {
          value: function (t) {
            this._element.innerHTML = t;
          }
        },
        created: function () {
          this.currentTag = this.tag || this.currentTag;
        },
        render: function (t) {
          return t(this.currentTag, {
            class: "fr-view"
          });
        },
        mounted: function () {
          this._element = this.$el, this.value && (this._element.innerHTML = this.value);
        },
        data: function () {
          return {
            currentTag: "div",
            _element: null
          };
        }
      };
      t.component("FroalaView", n);
    };
  }]);
});